import { render, staticRenderFns } from "./BackofficeEnviaCodigoUnicoMaterial.vue?vue&type=template&id=ea410eb4"
import script from "./BackofficeEnviaCodigoUnicoMaterial.vue?vue&type=script&lang=ts"
export * from "./BackofficeEnviaCodigoUnicoMaterial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports